import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function fetchOwnerPayments() {
  const response = await apiClient.get("/api/v1/payments/");
  return response.data;
}

function useOwnerPayments() {
  return useQuery({
    queryKey: ["owner-payments"],
    queryFn: fetchOwnerPayments,
  });
}

export { useOwnerPayments };
